import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

/** Fallbacks only. The live store name and details come from the store settings in the database. */
export const siteConfig: SiteConfig = {
    name: 'نايل بلاست',
    description: 'متجر منتجات بلاستيك بالجملة والقطاعي في مصر: أدوات مطبخ، تخزين، تنظيف، أثاث ومستلزمات تعبئة، مع شحن لكل المحافظات.',
    placeholder: '',
    url: getOrigin()
}
